import { addDatadogRumAction } from './datadogRum';
export function trackNavl(destinations) {
    addDatadogRumAction('HC NO RESULTS', { destinations });
}
